export interface IPosition {
    top: string;
    left: string;
    bottom: string;
    resultPos: string;
}

export type Positions = 'right' | 'left' | 'top' | 'bottom' | 'top-left';

export const getPosition = (
    container: HTMLElement,
    tooltip: HTMLElement,
    position: Positions,
): IPosition => {
    const { bottom, top, left, height, width } =
        container.getBoundingClientRect();
    const { height: tHeight, width: tWidth } = tooltip.getBoundingClientRect();

    const fitsBelow = bottom + tHeight < window.innerHeight;
    const estimatedTop = top - tHeight;
    const fitsTop = estimatedTop > 0;
    const maxBottom = window.innerHeight - tHeight;
    const estimatedBottom = window.innerHeight - bottom + height;

    switch (position) {
        case 'top': return {
            left: `${left + width / 2}px`,
            top: fitsTop
                ? `${estimatedTop}px`
                : fitsBelow
                    ? `${bottom}px` : 'auto',
            bottom: fitsBelow ? 'auto' : `${estimatedBottom}px`,
            resultPos: fitsTop ? 'top' : fitsBelow ? 'bottom' : 'top',
        };
        case 'bottom': return {
            left: `${left + width / 2}px`,
            top: fitsBelow ? `${bottom}px` : estimatedTop < 0 ? '0px' : 'auto',
            bottom: fitsBelow || maxBottom < estimatedBottom ? 'auto' : `${estimatedBottom}px`,
            resultPos: fitsBelow ? 'bottom' : 'top',
        };
        case 'left': return {
            left: `${left - tWidth}px`,
            top: `${top + height / 2}px`,
            bottom: 'auto',
            resultPos: 'left',
        };
        case 'right': return {
            left: `${left + width}px`,
            top: `${top + height / 2}px`,
            bottom: 'auto',
            resultPos: 'right',
        };
        case 'top-left': return {
            left: `${left - tWidth}px`,
            top: fitsTop ? `${estimatedTop}px` : '0px',
            bottom: 'auto',
            resultPos: 'top-left',
        };
        default: return {
            left: `${left + width / 2}px`,
            top: fitsTop
                ? `${estimatedTop}px`
                : fitsBelow
                    ? `${bottom}px` : 'auto',
            bottom: fitsTop ? 'auto' : `${estimatedBottom}px`,
            resultPos: fitsTop ? 'top' : 'bottom',
        };
    }
};
